import type {
  SenseEvent,
  EventTemplate,
  ClientEventType,
  BrandingSettings,
} from 'src/types/events';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'draft-js/lib/RawDraftContentState'. '/Users/diwaker/SpacedOut/ui-server/node_modules/draft-js/lib/RawDraftContentState.js' implicitly has an 'any' type.
import type {RawDraftContentState} from 'draft-js/lib/RawDraftContentState';

import {EventTypeEnum} from 'src/stores/event';

import {
  findDynamicLabelsInString,
  findMustacheLabelsInString,
  findTempLabelsInString,
} from 'src/components/lib/markdown-editor/dynamic-text';

import {getPlaceholderEntitiesCount} from 'src/components/lib/markdown-editor/draft-placeholder';

import {findJobVariablesInString} from 'src/utils/job-match';


export function findUniqueEntityVariablesInEvent(
  event: SenseEvent,
  template?: EventTemplate,
): Set<string> {
  return new Set(findAllEntityVariablesInEvent(event, template));
}

export function* findModuleEntityVariablesInEvent(
  event: SenseEvent,
): Generator<string, void, void> {
  for (const module of event.questions) {
    // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
    if (typeof module.question === 'string') {
      // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
      yield* findDynamicLabelsInString(module.question);
    }

    // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
    if (module.rte_json) {
      // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
      const {rte_json} = module;

      for (const entity of Object.values(rte_json.entityMap)) {
        // TODO (kyle): find flowtype for Entity
        // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
        if (entity.type === 'DYNAMIC_LABEL') {
          // TODO (kyle): name or value?
          // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
          yield entity.data.value;
        }
      }

      // NOTE (angelina): adding this additional loop in cases where entityMap has not been populated correctly. Dupes could be eliminated by calling findUniqueEntityVariablesInEvent. See https://github.com/Spaced-Out/sense/issues/15929 for additional details
      for (const block of rte_json.blocks) {
        yield* findDynamicLabelsInString(block.text);
      }
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
    } else if (module.text) {
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
      yield* findDynamicLabelsInString(module.text);
      // @ts-expect-error - TS2339 - Property 'beefree_html' does not exist on type 'Question'.
    } else if (module.beefree_html) {
      // @ts-expect-error - TS2339 - Property 'beefree_html' does not exist on type 'Question'.
      yield* findMustacheLabelsInString(module.beefree_html);
    }

    // (rng) - There is a bug in validating Digest List attributes, so commenting out until Nilarnab can debug
    // if (module.attributesToInclude) {
    //   yield* module.attributesToInclude;
    // }
  }
}

export function* findAllEntityVariablesInEvent(
  event: SenseEvent,
  template?: EventTemplate,
): Generator<string, void, void> {
  if (event.dynamicDeliveryAddress) {
    yield event.dynamicDeliveryAddress;
  }

  if (event.subject) {
    yield* findDynamicLabelsInString(event.subject);
  }

  yield* findAllEntityVariablesInBrandingSettings(event.brandingSettings);

  if (event.beefreeJson) {
    yield* findAllEntityVariablesInBeeFreeJson(event.beefreeJson);
  }

  for (const module of event.questions) {
    // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
    if (typeof module.question === 'string') {
      // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
      yield* findDynamicLabelsInString(module.question);
    }

    // @ts-expect-error - TS2339 - Property 'writeback' does not exist on type 'Question'.
    if (module.writeback) {
      // @ts-expect-error - TS2339 - Property 'writeback' does not exist on type 'Question'.
      yield module.writeback.attribute_name;
    }

    // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
    if (module.rte_json) {
      // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
      const {rte_json} = module;

      for (const entity of Object.values(rte_json.entityMap)) {
        // TODO (kyle): find flowtype for Entity
        // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
        if (entity.type === 'DYNAMIC_LABEL') {
          // TODO (kyle): name or value?
          // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
          yield entity.data.value;
        }
      }

      // NOTE (angelina): adding this additional loop in cases where entityMap has not been populated correctly. Dupes could be eliminated by calling findUniqueEntityVariablesInEvent. See https://github.com/Spaced-Out/sense/issues/15929 for additional details
      for (const block of rte_json.blocks) {
        yield* findDynamicLabelsInString(block.text);
      }
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
    } else if (module.text) {
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
      yield* findDynamicLabelsInString(module.text);
      // @ts-expect-error - TS2339 - Property 'beefree_html' does not exist on type 'Question'.
    } else if (module.beefree_html) {
      // @ts-expect-error - TS2339 - Property 'beefree_html' does not exist on type 'Question'.
      yield* findMustacheLabelsInString(module.beefree_html);
    }
    //SM-136 allow for job variables preview
    // @ts-expect-error - TS2339 - Property 'include_job_block' does not exist on type 'Question'.
    if (module.include_job_block === true) {
      // @ts-expect-error - TS2339 - Property 'job_match_rte_json' does not exist on type 'Question'. | TS2339 - Property 'alt_rte_json' does not exist on type 'Question'.
      const {job_match_rte_json, alt_rte_json} = module;
      if (job_match_rte_json) {
        yield* findVariablesInDraftContent(job_match_rte_json);
      }
      //also check alt_rte
      if (alt_rte_json) {
        yield* findVariablesInDraftContent(alt_rte_json);
      }
    }

    // NOTE(marcos): this allows us to check handcrafted variables in html templates
    // for validity before doing a test send
    if (template?.html) {
      yield* findMustacheLabelsInString(template.html);
    }

    // @ts-expect-error - TS2339 - Property 'attributesToInclude' does not exist on type 'Question'.
    if (module.attributesToInclude) {
      // @ts-expect-error - TS2339 - Property 'attributesToInclude' does not exist on type 'Question'.
      yield* module.attributesToInclude;
    }
  }
}

export function tempVarsInEvent(event: SenseEvent): Set<string> {
  return new Set(findAllTempVariables(event));
}

export function placeholderCountInEvent(event: SenseEvent): number {
  return countAllPlaceholderVariablesInEvent(event);
}

export function* findVariablesInDraftContent(
  rte_json: RawDraftContentState,
): Generator<string, void, void> {
  for (const entity of Object.values(rte_json?.entityMap)) {
    // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
    if (entity.type === 'DYNAMIC_LABEL') {
      // @ts-expect-error - TS18046 - 'entity' is of type 'unknown'.
      yield entity.data.value;
    }
  }
  for (const block of rte_json?.blocks) {
    yield* findJobVariablesInString(block.text);
  }
}

export function* findAllTempVariables(
  event: SenseEvent,
): Generator<string, void, void> {
  if (event.subject) {
    yield* findTempLabelsInString(event.subject);
  }

  for (const key of [
    'emailFromAddress',
    'emailFromName',
    'alertEmails',
    'emailCcList',
    'emailBccList',
  ]) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BrandingSettings'.
    if (event.brandingSettings?.[key]) {
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BrandingSettings'.
      yield* findTempLabelsInString(event.brandingSettings[key]);
    }
  }

  for (const module of event.questions) {
    // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
    if (typeof module.question === 'string') {
      // @ts-expect-error - TS2339 - Property 'question' does not exist on type 'Question'.
      yield* findTempLabelsInString(module.question);
    }

    // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
    if (module.rte_json) {
      // @ts-expect-error - TS2339 - Property 'rte_json' does not exist on type 'Question'.
      const {rte_json} = module;

      // NOTE (angelina): adding this additional loop in cases where entityMap has not been populated correctly. Dupes could be eliminated by calling findUniqueEntityVariablesInEvent. See https://github.com/Spaced-Out/sense/issues/15929 for additional details
      for (const block of rte_json.blocks) {
        yield* findTempLabelsInString(block.text);
      }
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
    } else if (module.text) {
      // @ts-expect-error - TS2339 - Property 'text' does not exist on type 'Question'.
      yield* findTempLabelsInString(module.text);
      // @ts-expect-error - TS2339 - Property 'beefree_json' does not exist on type 'Question'.
    } else if (module.beefree_json) {
      // @ts-expect-error - TS2339 - Property 'beefree_json' does not exist on type 'Question'.
      yield* findTempLabelsInString(JSON.stringify(module.beefree_json));
    }
  }
}

export function countAllPlaceholderVariablesInEvent(event: SenseEvent): number {
  let count = 0;
  for (const module of event.questions) {
    // @ts-expect-error - TS2339 - Property 'draftEditorState' does not exist on type 'Question'.
    if (module.draftEditorState) {
      // @ts-expect-error - TS2339 - Property 'draftEditorState' does not exist on type 'Question'.
      count += getPlaceholderEntitiesCount(module.draftEditorState) ?? 0;
    }
  }
  return count;
}

// TODO (kyle): not sure this is necessary. maybe fold it back into
// the `event` function above.
function* findAllEntityVariablesInBrandingSettings(
  brandingSettings: BrandingSettings,
): Generator<string, void, void> {
  for (const key of [
    'emailFromAddress',
    'emailFromName',
    'alertEmails',
    'emailCcList',
    'emailBccList',
  ]) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BrandingSettings'.
    if (brandingSettings[key]) {
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BrandingSettings'.
      yield* findDynamicLabelsInString(brandingSettings[key]);
    }
  }
}

/**
 * This function attempts to ignore the underlying structure
 * of the BeeFree JSON at the cost of doing a full traversal.
 */
function* findAllEntityVariablesInBeeFreeJson(
  json: Record<any, any>,
): Generator<string, void, void> {
  for (const [key, value] of Object.entries(json)) {
    if (key === 'html' && typeof value === 'string') {
      yield* findMustacheLabelsInString(value);
    } else if (value != null && typeof value === 'object') {
      yield* findAllEntityVariablesInBeeFreeJson(value);
    }
  }
}

export const isSMS = (eventType: ClientEventType): boolean =>
  [
    EventTypeEnum.SMS_Message,
    EventTypeEnum.SMS_Survey,
    EventTypeEnum.SMS_Chatbot,
    EventTypeEnum.SMS_NPS,
    EventTypeEnum.SMS_Job,
    // @ts-expect-error - TS2345 - Argument of type 'ClientEventType' is not assignable to parameter of type '"sms_message" | "sms_survey" | "sms_chatbot" | "sms_job" | "sms_nps"'.
  ].includes(eventType);

export const isEmail = (eventType: ClientEventType): boolean =>
  [
    EventTypeEnum.Message,
    EventTypeEnum.Survey,
    EventTypeEnum.List,
    EventTypeEnum.NPS,
    EventTypeEnum.BeeFree_Email,
    EventTypeEnum.BeeFree_Chatbot,
    // @ts-expect-error - TS2345 - Argument of type 'ClientEventType' is not assignable to parameter of type '"message" | "survey" | "nps" | "digest_email" | "beefree_email" | "beefree_chatbot"'.
  ].includes(eventType);

export const isSurvey = (eventType: ClientEventType): boolean =>
  [
    EventTypeEnum.Survey,
    EventTypeEnum.SMS_Survey,
    EventTypeEnum.NPS,
    EventTypeEnum.SMS_NPS,
    // @ts-expect-error - TS2345 - Argument of type 'ClientEventType' is not assignable to parameter of type '"survey" | "sms_survey" | "nps" | "sms_nps"'.
  ].includes(eventType);

export const isRespondable = (eventType: ClientEventType): boolean =>
  [EventTypeEnum.Survey, EventTypeEnum.SMS_Survey, EventTypeEnum].includes(
    // @ts-expect-error - TS2345 - Argument of type 'ClientEventType' is not assignable to parameter of type '"survey" | "sms_survey" | EventTypeEnumType'.
    eventType,
  );

export const eventDisplayName = (
  eventType: ClientEventType,
  t: (arg1: string, arg2: string) => string,
): string => {
  switch (eventType) {
    case EventTypeEnum.Survey:
      return t('Survey', 'Survey');
    case EventTypeEnum.SMS_Message:
      return t('SMS', 'SMS');
    case EventTypeEnum.SMS_Survey:
      return t('SMS_Survey', 'SMS Survey');
    case EventTypeEnum.SMS_Chatbot:
      return t('SMS_Chatbot', 'SMS Chatbot');
    case EventTypeEnum.NPS:
      return t('NPS', 'NPS');
    case EventTypeEnum.SMS_NPS:
      return t('SMS_NPS', 'SMS NPS');
    case EventTypeEnum.List:
      return t('Digest_List', 'Digest List');
    case EventTypeEnum.BeeFree_Email:
      return t('Rich_Email', 'Rich Email');
    case EventTypeEnum.BeeFree_Chatbot:
      return t('Rich_Email_Chatbot', 'Rich Email Chatbot');
    case EventTypeEnum.Bulk_Writeback:
      return t('Bulk_Writeback', 'Bulk Writeback');
    case EventTypeEnum.Message:
    default:
      return t('Message', 'Message');
  }
};

export const getMaxAllowedChoiceNumber = (
  choices: {
    value: string;
    label: string;
  }[],
  maxLength?: number | null,
): number => {
  if (!maxLength || choices.length === 0) {
    return choices.length;
  }

  const sortedChoices = [...choices].sort(
    (a, b) => b.value.length - a.value.length,
  );

  if (maxLength < sortedChoices[0].value.length) {
    return 0;
  } //unlikely case where if hit, changes may have to be made to the data, but adding this here just as a safeguard

  let choicesCharSum = 0;
  let result = 0;
  for (let i = 0; i < sortedChoices.length; i++) {
    if (choicesCharSum >= maxLength) {
      break;
    }
    choicesCharSum += sortedChoices[i].value.length;
    result++;
  }

  return result;
};

export const getMultiSelectOptions = (
  maxAllowedChoiceNumber: number,
  numEnabledChoices: number,
): Array<{
  value: number;
  label: string;
}> => {
  const result = [{value: 1, label: 'one choice'}];
  const numOptions = Math.min(maxAllowedChoiceNumber, numEnabledChoices);

  for (let i = 1; i < numOptions; i++) {
    let label = `${i + 1} choices`;
    if (i === numEnabledChoices - 1) {
      label += ' (all)';
    } else if (i === numOptions - 1) {
      label += ' (max)';
    }

    result.push({
      value: i + 1,
      label,
    });
  }

  return result;
};
